import React from 'react';
import { FiCheck, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ComparisonTable = () => {
  const specs = [
    { label: 'Security Rating', v1: '03 / 10', v2: '08 / 10', v3: '10 / 10' },
    { label: 'Casing Material', v1: 'Polymer', v2: 'Hardened Steel', v3: 'Titanium Alloy' },
    { label: 'Anti-Cut Defense', v1: false, v2: true, v3: true },
    { label: 'Smart Integration', v1: false, v2: 'Optional', v3: 'Built-in' },
    { label: 'Weight (KG)', v1: '0.4', v2: '1.6', v3: '2.8' },
  ];

  return (
    <section id="compare" className="py-32 bg-asphalt overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-signal font-black text-xs tracking-[0.4em] uppercase">Data Verification</span>
          <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4">
            Technical <span className="text-stroke">Specs.</span>
          </h2>
        </div>

        <div className="overflow-x-auto pb-8">
          <table className="w-full border-collapse min-w-[800px]">
            <thead>
              <tr>
                <th className="p-8 text-left bg-asphalt-dark/50 border-b border-white/5"></th>
                {['Flex Series', 'Titan Series', 'ChainGuard Pro'].map((h, i) => (
                  <th key={i} className={`p-8 text-center border-b ${i === 1 ? 'border-signal bg-signal/5' : 'border-white/5 bg-asphalt-dark/30'}`}>
                    <h3 className="text-xl font-black uppercase tracking-widest">{h}</h3>
                    <p className="text-[10px] text-gray-500 uppercase mt-2 tracking-widest font-bold">Performance Grade</p>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {specs.map((row, idx) => (
                <tr key={idx} className="group border-b border-white/5 hover:bg-white/5 transition-colors">
                  <td className="p-8 text-sm font-black uppercase tracking-widest text-gray-400 group-hover:text-white">{row.label}</td>
                  <td className="p-8 text-center text-sm font-bold text-gray-500 uppercase tracking-wider">{row.v1 === false ? <SafeIcon icon={FiMinus} className="mx-auto" /> : row.v1}</td>
                  <td className="p-8 text-center text-sm font-black text-white uppercase tracking-wider bg-white/5">{row.v2 === true ? <SafeIcon icon={FiCheck} className="text-signal mx-auto text-xl" /> : row.v2}</td>
                  <td className="p-8 text-center text-sm font-bold text-gray-500 uppercase tracking-wider">{row.v3 === true ? <SafeIcon icon={FiCheck} className="text-signal mx-auto text-xl" /> : row.v3}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;